export class user
{
    location:any;
    subLocation:any;
    accessCode:any;
    accessPoint:any;
}